import type { ReactNode, ButtonHTMLAttributes } from 'react'
import { getBookingUrl } from '@/lib/booking'
import { useBooking } from '@/hooks/useBooking'
import { cn } from '@/lib/utils'

const MAILTO = 'mailto:hello@gigafish.co?subject=Discovery%20call'

type BookCallButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onClick' | 'type'> & {
  children: ReactNode
  /** Extra classes for the mailto fallback anchor when no booking URL is set. */
  fallbackClassName?: string
}

/**
 * Opens the Google Calendar (or other) booking page in an in-app modal.
 * Falls back to mailto when VITE_BOOKING_URL is unset.
 */
export default function BookCallButton({
  children,
  className,
  fallbackClassName,
  ...props
}: BookCallButtonProps) {
  const bookingUrl = getBookingUrl()
  const { openBooking } = useBooking()

  if (!bookingUrl) {
    return (
      <a href={MAILTO} className={cn(className, fallbackClassName)}>
        {children}
      </a>
    )
  }

  return (
    <button type="button" className={className} onClick={openBooking} {...props}>
      {children}
    </button>
  )
}
